import { Component, OnInit } from '@angular/core';
import { SeoService } from '@app/core/seo/seo.service';
import { ensureLottiePlayer } from '@app/core/lottie/lottie-loader';
import { ConfigService } from 'esz-saas-lcp-ng-crud-ui';

@Component({
    standalone: false,
    selector: 'app-ws-aboutus',
    templateUrl: './ws-aboutus.component.html',
    styleUrls: ['./ws-aboutus.component.scss']
})
export class WsAboutusComponent implements OnInit {

    /** The "How we work" grid. Each entry is a fact about BMS or the team, not a slogan. */
    coreValues = [
        {
            icon: 'pi pi-desktop',
            title: 'Product first',
            description: 'Every engagement starts from working software you can click through, not a slide deck. The free edition exists so you can try the real thing before you talk to us.'
        },
        {
            icon: 'pi pi-code',
            title: 'Open by design',
            description: 'REST, Integration Platform webhooks and MCP servers on every module, so your tools and AI agents work with your data. Your data sits in standard relational databases and object storage and leaves with you.'
        },
        {
            icon: 'pi pi-lock',
            title: 'Isolated and audited',
            description: 'Each customer gets its own schema, single sign-on, fine-grained relationship-based permissions and its own web apps. Every change is versioned, so you can see who did what and when.'
        },
        {
            icon: 'pi pi-users',
            title: 'Built by the people who run it',
            description: 'The engineers who write BMS also implement, integrate and support it. Questions reach an engineer, not a ticket queue.'
        }
    ];

    benefits = [
        {
            icon: 'pi pi-lock',
            title: 'Isolated and audited',
            description: 'Every customer gets its own data, single sign-on, fine-grained access control and its own web apps; every change is versioned, so you can see who did what and when.'
        },
        {
            icon: 'pi pi-th-large',
            title: 'One sign-in, sixteen modules',
            description: 'Catalog, orders, POS, bookings, loyalty, CRM, documents, Business Process Management System (workflows, cases & decisions), HR and accounting share one identity and one API style. Add a module without a migration project.'
        },
        {
            icon: 'pi pi-desktop',
            title: 'Yours to run',
            description: 'The same applications ship as a free local edition you can run on a laptop. No lock-in: your data is in a standard relational database, your files in object storage, your APIs documented.'
        },
        {
            icon: 'pi pi-users',
            title: 'A team that ships',
            description: 'The people who write the software also implement it, integrate it and support it. Questions reach an engineer, not a ticket queue.'
        }
    ];

    constructor(public configService: ConfigService, private seo: SeoService) { }

    ngOnInit(): void {
        this.seo.set({
            title: 'About us',
            description: 'ESZES Consultancy & Services, Thrissur, Kerala: the team behind BMS, a multi-tenant business management platform with a staff app and a REST and MCP API for every module.',
            path: '/aboutus'
        });
        ensureLottiePlayer();
    }
}
